/** Endpoints #33-#34 — re-map trigger and background job progress. */

import type { JobResponse, RemapBody, RemapResponse } from '@lw/shared';
import { apiJson } from './client';

/** #33 `POST /api/admin/remap` — empty body re-maps everything stale (§7.5). */
export function requestRemap(body: RemapBody = {}): Promise<RemapResponse> {
  return apiJson<RemapResponse>('/admin/remap', { method: 'POST', body });
}

/** #34 `GET /api/jobs/:id` — also patched live by the `job.progress` SSE event. */
export function getJob(jobId: number, signal?: AbortSignal): Promise<JobResponse> {
  return apiJson<JobResponse>(`/jobs/${jobId}`, { signal });
}
